import { FC } from 'react';
import { Plus, Check } from 'lucide-react';
import { Course } from '@teachur/http-client';
import { cn } from '@new/lib';

interface AddCourseItemProps {
  course: Course;
  isAdded: boolean;
  onAdd: (courseId: number) => void;
}

export const AddCourseItem: FC<AddCourseItemProps> = ({ course, isAdded, onAdd }) => {
  const action = isAdded
    ? {
        label: 'Added',
        Icon: Check,
        className: 'text-(--success-S700)!',
      }
    : {
        label: 'Add',
        Icon: Plus,
        className: 'text-(--primary-O900)!',
      };

  const handleClick = () => {
    if (!isAdded) {
      onAdd(course.id);
    }
  };

  return (
    <div className="flex items-center justify-between gap-2 p-3 border border-(--neutral-black-NB200) rounded-lg">
      <div className="flex flex-col gap-1 w-full md:w-auto">
        <div className="flex flex-col lg:flex-row lg:items-center gap-2">
          <h3 className="text-(--neutral-black-NB1000)! [font-size:var(--fs-p4)] lg:[font-size:var(--fs-p3)] font-semibold! m-0!">
            {course.name}
          </h3>

          {course.code && (
            <span className="w-fit rounded bg-(--neutral-black-NB100)">
              <span className="p-1.5 text-(--neutral-black-NB700)! font-['Montserrat'] text-[11px] font-medium leading-tight">
                {course.code}
              </span>
            </span>
          )}
        </div>
      </div>

      <div
        className={cn(
          'flex h-10 p-2 justify-center items-center gap-1 shrink-0 rounded-lg',
          !isAdded && 'transition-colors cursor-pointer hover:bg-(--primary-O100)'
        )}
        onClick={handleClick}
      >
        <span className="flex gap-1 items-center">
          <action.Icon size={14} className={action.className} />
          <span
            className={cn(
              '[font-family:var(--font-arvo)] [font-size:var(--fs-p4)] font-bold leading-[125%]',
              action.className
            )}
          >
            {action.label}
          </span>
        </span>
      </div>
    </div>
  );
};
